export function cloneData2D(data) {
    const newData = {};
    if (isData2DFt(data)) {
        for (const key in data) {
            addCloneData(newData, key, data[key]);
        }
    }
    else {
        for (const key in data) {
            addCloneData(newData, key, data[key]);
        }
    }
    return newData;
}
function isData2DFt(data) {
    return 're' in data;
}
function addCloneData(newData, key, data) {
    if (data) {
        const { z, ...other } = data;
        newData[key] = { z: z.slice(), ...other };
    }
}
//# sourceMappingURL=cloneData2D.js.map